import React from 'react';
import ExperienceReview from './common/experience-review';

const VideoReview: React.FunctionComponent = (): JSX.Element => {
  return <ExperienceReview experienceType="video" />;
};

export default VideoReview;
